import { Box, styled, Switch, Typography } from '@mui/material';

type PartnerSettingsCardProps = {
  name: string;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
};

export const PartnerSettingsCard = (props: PartnerSettingsCardProps) => {
  const { name, checked, disabled, onCheckedChange } = props;
  return (
    <PartnerSettingsWrapper>
      <Typography variant="h2">{name}</Typography>
      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="body1">{checked ? 'On' : 'Off'}</Typography>
        <Switch
          checked={checked}
          disabled={disabled}
          color="primary"
          inputProps={{ 'aria-label': `${name} toggle` }}
          onChange={(e) => onCheckedChange(e.target.checked)}
        />
      </Box>
    </PartnerSettingsWrapper>
  );
};

const PartnerSettingsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(5),
  marginBottom: theme.spacing(3),
  backgroundColor: theme.palette.lwPrimaryAccentDark?.[10],
  borderRadius: theme.spacing(3),
}));
